import { useState } from 'react'
import "./style.css";
import axios from "axios";
import { toast } from "react-toastify";

const ConfirmOrgModalForm = ({
  orgId,
  setOrgId,
  openConfirmOrgModal,
  setOpenConfirmOrgModal,
  fetchOrganizations,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleDeleteOrg = () => {
     setIsLoading(true)
    axios.delete(`${process.env.REACT_APP_API_V3_URL}/org/${orgId}`)
      .then((res) => {
        toast.success("Organization have been deleted");
        fetchOrganizations();
        setOpenConfirmOrgModal({
          isOpen: false,
          type: null
        });
        setOrgId(null);
        setIsLoading(false)
      })
      .catch((err) => {
         setIsLoading(false)
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
      });
  }


  const handleApproveOrg = () => {
    setIsLoading(true)
    axios.patch(`${process.env.REACT_APP_API_V3_URL}/org/${orgId}`)
    .then((res) => {
      toast.success("Organization have been approved");
      fetchOrganizations();
      setOpenConfirmOrgModal({
        isOpen: false,
        type: null
      });
      setOrgId(null);
      setIsLoading(false)
    }).catch((err) => {
      setIsLoading(false)
      if (err && err.response && err.response?.data && err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Technical Error, Please Try Again");
      }
    });
  }


  return (
    <>
    <div>
      <h4>
        Are you sure you want to{" "}
        <span className={`${openConfirmOrgModal.type === "Approve" ? "text-success" : "text-danger"} fw-bold`}>
          {openConfirmOrgModal.type === "Approve" ? "Approve" : "Delete"}
        </span>{" "}
        this Organization?
      </h4>
      <div className="text-center pt-5">
        <button
          type="reset"
          onClick={() => {
            setOpenConfirmOrgModal({
              isOpen: false,
              type: null
            });
            setOrgId(null);
          }}
          className="btn btn-light me-3"
          data-kt-users-modal-action="cancel"
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`btn ${openConfirmOrgModal.type === "Approve" ? "bg-success" : "bg-danger"} text-white`}
          data-kt-users-modal-action="submit"
          onClick={openConfirmOrgModal?.type === 'Approve' ? handleApproveOrg : handleDeleteOrg}
          disabled={isLoading}
        >
          <span className="indicator-label">{openConfirmOrgModal?.type === 'Approve' ? 'Approve' : 'Delete'} Organization</span>
        </button>
      </div>
    </div>
  </>
  );
};

export { ConfirmOrgModalForm };
